(function () {
  'use strict';

  window.VenucastSolutionFinderConfig = {
    version: 'prototype-2026-09-03-v7',

    products: {
      auraplex_m3: { handle: 'auraplex-m3-auracast-assistive-listening-kit', fallbackTitle: 'AuraPlex M3', trialEligible: true },
      auraplex_mx: { handle: 'auraplex-mx-auracast-wireless-transmitter-receiver', fallbackTitle: 'AuraPlex MX', trialEligible: true },
      auraplex_x20: { handle: 'auraplex-x20-pro-auracast-assistive-listening-system', fallbackTitle: 'AuraPlex X20 Pro', trialEligible: true },
      aircast: { handle: 'aircast-professional-auracast-transmitter', fallbackTitle: 'AirCast', trialEligible: true },
      oasis_aura: { handle: 'oasis-aura-auracast-transmitter', fallbackTitle: 'Oasis Aura', trialEligible: true },
      netcast: { handle: 'netcast-enterprise-auracast-audio-distribution-system', fallbackTitle: 'NetCast', trialEligible: true },
      auraclip_3rx: { handle: 'auraclip-3rx-auracast-receiver-kit', fallbackTitle: 'AuraClip 3RX' },
      auraclip_10rx: { handle: 'auraclip-10rx-auracast-receiver-kit', fallbackTitle: 'AuraClip 10RX' },
      auraclip_receiver: { handle: 'auraclip-auracast-receiver', fallbackTitle: 'AuraClip' },
      auraview_receiver: { handle: 'auraview-auracast-assistive-listening-receivers-screen-display', fallbackTitle: 'AuraView' },
      aria_aura: { handle: 'aria-aura-wireless-tv-headphones', fallbackTitle: 'Aria Aura' },
      auraband_receiver: { handle: 'auraband-auracast-personal-receiver', fallbackTitle: 'AuraBand' },
      auracoil_2: { handle: '3902-auracast-receivers', fallbackTitle: 'AuraCoil 2-Pack' },
      auraband_2: { handle: '3912-auracast-receivers', fallbackTitle: 'AuraBand 2-Pack' },
      harmony_a0_solo: { handle: 'harmony-a0-solo', fallbackTitle: 'Harmony A0 Solo' },
      wired_headphones_3: { handle: '3-pack-wired-on-ear-headphones', fallbackTitle: '3-Pack Wired On-Ear Headphones' },
      wired_headphones_10: { handle: '10-pack-wired-on-ear-headphones', fallbackTitle: '10-Pack Wired On-Ear Headphones' },
      c83: { handle: 'c83-auracast-wireless-usb-c-receiver-for-phone', fallbackTitle: 'Aura C' },
      tcoil_390: { handle: '39091-auracast-receivers', fallbackTitle: '39091' },
      quartet_2: { handle: 'quartet-2-multi-user-wireless-headpones-system', fallbackTitle: 'Quartet 2' },
      quartet_extra: { handle: 'q5049-2-4g-headphones', fallbackTitle: 'Quartet-Extra' },
      quartet_charging: { handle: 'multi-charging-cable-for-quartet-type-c', fallbackTitle: 'Multi Charging Cable for Quartet' },
      ut90_transmitter: { handle: 'v-ut90-transmitter', fallbackTitle: 'V-UT90 Transmitter' },
      ut90_headphones_6: { handle: '6-pack-v-ut90-headphones', fallbackTitle: '6-Pack V-UT90 Headphones' },
      auditour: { handle: 'auditour-wireless-tour-guide-system', fallbackTitle: 'AudiTour' },
      auditour_expansion: { handle: 'auditour-expansion-kit', fallbackTitle: 'AudiTour Expansion Kit' },
      auditour_headphones_10: { handle: 'auditour-add-on-open-ear-headphones-10-pack', fallbackTitle: 'AudiTour Add-On Open-Ear Headphones (10-Pack)' }
    },

    solutionTypes: [
      { value: 'assistive_listening', icon: '🦻', label: 'Assistive Listening', description: 'Help people hear speech, presentations or performances more clearly.' },
      { value: 'audio_distribution', icon: '🔊', label: 'Audio Distribution', description: 'Distribute synchronized audio to speakers across multiple rooms or zones.' },
      { value: 'caption_display', icon: '💬', label: 'Conference Caption Text Display', description: 'Send conference audio to phones for personal live caption text.' }
    ],

    useCases: [
      { value: 'church', solutionType: 'assistive_listening', icon: '⛪', label: 'Church / Place of Worship', description: 'Personal listening for services, sermons and community programs.' },
      { value: 'theater', solutionType: 'assistive_listening', icon: '🎭', label: 'Theater / Auditorium', description: 'Accessible listening for performances, films and presentations.' },
      { value: 'classroom', solutionType: 'assistive_listening', icon: '🎓', label: 'Classroom / Education', description: 'Clearer lectures, lessons and student presentations.' },
      { value: 'meeting', solutionType: 'assistive_listening', icon: '👥', label: 'Meeting / Conference', description: 'Personal audio for meetings, panels and conferences.' },
      { value: 'senior_living', solutionType: 'assistive_listening', icon: '♥', label: 'Senior Living / Community', description: 'Easy listening options for activities, TV and group discussions.' },
      { value: 'guided_tour', solutionType: 'assistive_listening', icon: '🎤', label: 'Museum / Guided Tour', description: "Send a guide's voice to a moving group." },
      { value: 'assistive_listening', solutionType: 'assistive_listening', icon: '🦻', label: 'Other Assistive Listening', description: 'Build a flexible accessible-listening setup for another venue.' },
      { value: 'multi_room', solutionType: 'audio_distribution', icon: '🏢', label: 'Multiple Rooms / Zones', description: 'Play synchronized audio through speakers in separate rooms or zones.' },
      { value: 'gym', solutionType: 'audio_distribution', icon: '🏋️', label: 'Gym / Fitness', description: 'Distribute class or program audio to speakers across workout zones.' },
      { value: 'outdoor_party', solutionType: 'audio_distribution', icon: '🎉', label: 'Outdoor Party / Event', description: 'Distribute event audio to wireless speakers across the outdoor space.' },
      { value: 'sports_bar', solutionType: 'audio_distribution', icon: '📺', label: 'Sports Bar / Multiple TVs', description: 'Create speaker zones for selected TV or venue audio.' },
      { value: 'church_overflow', solutionType: 'audio_distribution', icon: '⛪', label: 'Church Overflow Rooms', description: 'Extend service audio to overflow, lobby or community rooms.' },
      { value: 'campus_audio', solutionType: 'audio_distribution', icon: '🏫', label: 'School / Campus', description: 'Distribute announcements or program audio across learning spaces.' },
      { value: 'public_space_audio', solutionType: 'audio_distribution', icon: '🏨', label: 'Hospitality / Public Spaces', description: 'Create shared speaker zones for lobbies, lounges or public areas.' },
      { value: 'distributed_audio', solutionType: 'audio_distribution', icon: '🔊', label: 'Other Multi-Zone Audio', description: 'Plan another multi-room or multi-zone speaker installation.' },
      { value: 'conference_caption', solutionType: 'caption_display', icon: '💬', label: 'Conference / Meeting Captions', description: 'Display live caption text on attendees’ personal phones.' }
    ],

    quantityRanges: [
      { value: '1-3', label: '1–3' },
      { value: '4-10', label: '4–10' },
      { value: '11-20', label: '11–20' },
      { value: '20+', label: '20+' }
    ],

    receiverPreferences: [
      { value: 'auraclip', productId: 'auraclip_receiver', image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/auraclip-m1-auracast-receiver_72acf678-aa20-430c-8054-96970a6fe526.png?v=1775716900', label: 'AuraClip receiver', description: 'Flexible clip-on receiver for wired headphones, earbuds or neckloops.' },
      { value: 'auraview', productId: 'auraview_receiver', image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/250V_1_2.png?v=1782723203', label: 'AuraView screen receiver', description: 'Best when several Auracast broadcasts may be available at the same time.' },
      { value: 'wireless_headphones', productId: 'aria_aura', image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/90R.png?v=1787799229', label: 'Wireless Auracast headphones', description: 'Completely wireless, high-quality listening with a built-in Auracast receiver.' },
      { value: 'auracoil', productId: 'auracoil_2', image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/AuraCoil-m1-auracast-receiver-s_e82facdd-754c-4c4b-965c-62fc491d5d9a.png?v=1782893746', label: 'AuraCoil 2-Pack for T-Coil hearing aids', description: 'Two neckloop receivers for visitors whose hearing aids support T-Coil / telecoil.' },
      { value: 'auraband', productId: 'auraband_2', image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/391-m1-auracast-wireless-earbuds-r_39f01135-65fc-455c-b040-810b1dd119b9.png?v=1783592054', label: 'AuraBand 2-Pack', description: 'For seniors with less arm movement: easy to wear and take off. Slim design fits a church-stool pocket next to a Bible.' },
      { value: 'aura_c', productId: 'c83', image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/aura-c-auracast-receiver-main-1.png?v=1788165908', label: 'Aura C for personal Bluetooth devices', description: 'Phone bridge for Bluetooth headphones or older Bluetooth hearing aids; plan for about 200 ms additional latency.' },
      { value: 'not_sure', icon: '❓', label: "I'm not sure", description: 'Show a flexible starting mix and confirm individual needs later.' }
    ],

    adaComplianceOptions: [
      { value: 'yes', icon: '✓', label: 'Yes — size for ADA planning', description: 'Use venue capacity to pre-fill the receiver target on the next step.' },
      { value: 'no', icon: '👥', label: 'No — use a planning suggestion', description: 'Start with a suggested quantity, then change it to match expected demand.' },
      { value: 'not_sure', icon: '❓', label: "I'm not sure", description: 'Keep the reference visible and confirm with an expert.' }
    ],

    audioSources: [
      { value: 'professional_mixer', icon: '🎚️', label: 'Mixer / soundboard', description: 'Yamaha, Behringer, Allen & Heath, Midas, Soundcraft, PreSonus, Mackie, QSC, DiGiCo / Avid, TASCAM / Zoom or similar.' },
      { value: 'aux', icon: '💻', label: 'Computer or other 3.5 mm audio-out device', description: 'PC, tablet, TV or another source with a headphone / AUX audio output.' },
      { value: 'not_sure', icon: '❓', label: "I'm not sure", description: 'We’ll flag the cable and input for confirmation.' }
    ],

    barriers: [
      { value: 'open', icon: '🏟️', label: 'One open area', description: 'Mostly clear line of sight between the transmitter and listeners.' },
      { value: 'light_partitions', icon: '🚪', label: 'Light partitions or interior walls', description: 'Drywall, curtains or movable partitions may reduce usable range.' },
      { value: 'concrete', icon: '🧱', label: 'Concrete walls or major separation', description: 'A managed multi-transmitter or networked design may be needed.' },
      { value: 'multiple_zones', icon: '🏢', label: 'Multiple rooms or listening zones', description: 'Audio must reach more than one distinct area.' },
      { value: 'not_sure', icon: '❓', label: "I'm not sure" }
    ],

    rules: [
      {
        id: 'assistive-listening-plan', enabled: true, priority: 220,
        conditions: { solutionType: ['assistive_listening'] },
        recommendation: {
          title: 'Assistive listening plan',
          subtitle: 'Standalone transmitter with a configurable receiver mix',
          reasonBullets: ['Transmitter follows the selected audio source', 'AuraClip provides at least 60% of the receiver plan', 'The remaining share can be spread across the selected specialist receiver styles'],
          groups: { transmitter: [], receivers: [], accessories: [] }
        }
      },
      {
        id: 'multi-zone-speaker-plan', enabled: true, priority: 220,
        conditions: { solutionType: ['audio_distribution'] },
        recommendation: {
          title: 'Multi-zone speaker distribution plan',
          subtitle: 'Standalone transmitter with Auracast speakers',
          reasonBullets: ['Designed for speaker distribution across rooms or zones', 'Does not add personal headphones', 'Final speaker placement should be confirmed from the site layout'],
          groups: { transmitter: [], receivers: [], accessories: [] }
        }
      },
      {
        id: 'conference-caption-display-plan', enabled: true, priority: 220,
        conditions: { solutionType: ['caption_display'] },
        recommendation: {
          title: 'Conference caption display plan',
          subtitle: 'Standalone transmitter with personal phone caption receivers',
          reasonBullets: ['Designed for conference and meeting caption text', 'Uses personal phone displays', 'Final caption service and network workflow should be confirmed'],
          groups: { transmitter: [], receivers: [], accessories: [] }
        }
      },
      {
        id: 'guided-tour', enabled: true, priority: 140,
        conditions: { useCase: ['guided_tour'] },
        recommendation: {
          title: 'AudiTour group setup',
          subtitle: 'Portable guide transmitter, receivers and open-ear listening options',
          reasonBullets: ["Designed to send a guide's voice to a moving group", 'Expansion kits keep receiver quantities configurable', 'Open-ear add-ons provide a consistent venue-supplied listening option'],
          groups: {
            transmitter: [{ productId: 'auditour', quantity: 1, reason: 'Core portable transmitter and receiver system for the guide.' }],
            receivers: [
              { productId: 'auditour_expansion', quantity: 'groupPacks10', reason: 'Adds venue-provided receivers in groups of 10.' },
              { productId: 'auditour_headphones_10', quantity: 'groupPacks10', reason: 'Adds open-ear headphones for each receiver group.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'silent-event-large', enabled: true, priority: 135,
        conditions: { useCase: ['silent_event'], minReceiverTarget: 31 },
        recommendation: {
          title: 'UT90 silent-event setup',
          subtitle: 'Multi-channel transmitter with expandable venue headphones',
          reasonBullets: ['Designed for larger silent events and conference listening', 'Six-headphone packs make the audience quantity easier to scale', 'Final channel and charging quantities should be confirmed for groups above 100'],
          groups: {
            transmitter: [{ productId: 'ut90_transmitter', quantity: 1, reason: 'Creates the wireless audio channel for the event.' }],
            receivers: [{ productId: 'ut90_headphones_6', quantity: 'groupPacks6', reason: 'Provides the wireless headphones people will wear.' }],
            accessories: []
          }
        }
      },
      {
        id: 'silent-event', enabled: true, priority: 130,
        conditions: { useCase: ['silent_event'] },
        recommendation: {
          title: 'Quartet 2 silent-listening setup',
          subtitle: 'Core transmitter plus expandable wireless headphones',
          reasonBullets: ['Built for multiple people listening at the same time', 'Works with common event audio sources', 'Extra headphones and charging cables can be added as the group grows'],
          groups: {
            transmitter: [{ productId: 'quartet_2', quantity: 1, reason: 'Core transmitter and starter headphone system.' }],
            receivers: [{ productId: 'quartet_extra', quantity: 'quartetExtras', reason: 'Adds one wireless listening headphone per additional person.' }],
            accessories: [{ productId: 'quartet_charging', quantity: 'quartetCharging', reason: 'Keeps larger headphone groups easier to charge.' }]
          }
        }
      },
      {
        id: 'segmented-or-networked', enabled: true, priority: 125,
        conditions: { any: [{ barriers: ['concrete', 'multiple_zones'] }, { useCase: ['distributed_audio', 'gym', 'outdoor_party', 'sports_bar', 'multi_room'] }] },
        recommendation: {
          title: 'NetCast managed venue setup',
          subtitle: 'Networked transmitter design for separated spaces or multiple zones',
          reasonBullets: ['Concrete walls and separated zones can reduce usable wireless coverage', 'NetCast supports a more managed, expandable installation', 'A site plan is needed to confirm transmitter placement and quantity'],
          groups: {
            transmitter: [{ productId: 'netcast', quantity: 'sitePlan', reason: 'Creates managed broadcasts across the required coverage zones.' }],
            receivers: [
              { productId: 'auraclip_10rx', quantity: 'receiverPacks10', reason: 'Provides venue receivers in manageable groups of 10.' },
              { productId: 'wired_headphones_10', quantity: 'receiverPacks10', reason: 'Gives each AuraClip receiver a simple venue-provided listening option.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'range-over-five-hundred-feet', enabled: true, priority: 129,
        conditions: { minRangeFeet: 501 },
        recommendation: {
          title: 'NetCast long-range site plan',
          subtitle: 'Managed transmitter design for distances beyond a standard single-room broadcast',
          reasonBullets: ['The source-to-last-row distance is more than 500 ft', 'A managed layout helps account for placement, interference and coverage', 'Final transmitter quantity should be confirmed from a site plan'],
          groups: {
            transmitter: [{ productId: 'netcast', quantity: 'sitePlan', reason: 'Provides the managed transmitter layer for the requested long-distance coverage.' }],
            receivers: [{ productId: 'auraclip_10rx', quantity: 'receiverPacks10', reason: 'Provides a starting venue receiver pool sized to the selected target.' }],
            accessories: []
          }
        }
      },
      {
        id: 'over-one-thousand-seats', enabled: true, priority: 128,
        conditions: { minVenueCapacity: 1001 },
        recommendation: {
          title: 'NetCast large-venue setup',
          subtitle: 'Long-range managed transmitter with scalable receiver packs',
          reasonBullets: ['Mapped to venues above 1,000 seats', 'Published line-of-sight range is up to 656 ft, subject to layout and interference', 'Receiver packs scale from venue capacity and the requested listening-device count'],
          groups: {
            transmitter: [{ productId: 'netcast', quantity: 'sitePlan', reason: 'Provides the managed transmitter layer for a large venue.' }],
            receivers: [
              { productId: 'auraclip_10rx', quantity: 'receiverPacks10', reason: 'Provides venue receivers in groups of 10.' },
              { productId: 'wired_headphones_10', quantity: 'receiverPacks10', reason: 'Pairs a venue headphone with each AuraClip receiver.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'range-three-hundred-twenty-nine-to-five-hundred-feet', enabled: true, priority: 124,
        conditions: { minRangeFeet: 329, maxRangeFeet: 500 },
        recommendation: {
          title: 'AirCast long-range setup',
          subtitle: 'Professional transmitter with receiver options sized to the selected target',
          reasonBullets: ['The source-to-last-row distance is above 328 ft', 'Published line-of-sight range is up to 500 ft, subject to walls, people and interference', 'Receiver style and quantity follow the preferences selected below'],
          groups: {
            transmitter: [{ productId: 'aircast', quantity: 1, reason: 'Provides the professional Auracast broadcast for the longer listening distance.' }],
            receivers: [{ productId: 'auraclip_10rx', quantity: 'receiverPacks10', reason: 'Provides venue receivers in groups of 10.' }],
            accessories: []
          }
        }
      },
      {
        id: 'ada-m3-up-to-two-hundred-seats', enabled: true, priority: 119,
        conditions: { adaCompliance: ['yes'], minVenueCapacity: 151, maxVenueCapacity: 200 },
        recommendation: {
          title: 'AuraPlex M3 ADA receiver setup',
          subtitle: '5403 core kit with regular and T-Coil receiver packs sized from venue capacity',
          reasonBullets: ['Uses seating capacity instead of a broad expected-listener range', 'Combines regular AuraClip receivers with hearing-aid-compatible AuraCoil receivers', 'Sellable three-receiver packs may provide slightly more than the calculated ADA reference'],
          groups: {
            transmitter: [{ productId: 'auraplex_m3', quantity: 1, reason: 'The 5403 core kit combines the venue transmitter, three AuraClip receivers and charging.' }],
            receivers: [
              { productId: 'auraclip_3rx', quantity: 'adaM3StandardPacks3', reason: 'Adds three AuraClip receivers for visitors who do not use hearing aids or who prefer a venue-provided receiver.' },
              { productId: 'tcoil_390', quantity: 'adaM3TelecoilPacks3', reason: 'Adds three hearing-aid-compatible AuraCoil neck loop receivers for visitors whose hearing aids use T-Coil / telecoil.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'five-hundred-one-to-one-thousand-seats', enabled: true, priority: 115,
        conditions: { minVenueCapacity: 501, maxVenueCapacity: 1000 },
        recommendation: {
          title: 'AirCast large-room setup',
          subtitle: 'Professional transmitter with receiver and headphone packs sized to demand',
          reasonBullets: ['Mapped to venues between 501 and 1,000 seats', 'Published line-of-sight range is up to 500 ft, subject to walls and interference', 'Separate receiver packs make the venue listening quantity expandable'],
          groups: {
            transmitter: [{ productId: 'aircast', quantity: 1, reason: 'Provides the professional Auracast broadcast for the main room.' }],
            receivers: [
              { productId: 'auraclip_10rx', quantity: 'receiverPacks10', reason: 'Provides venue receivers in groups of 10.' },
              { productId: 'wired_headphones_10', quantity: 'receiverPacks10', reason: 'Pairs a venue headphone with each AuraClip receiver.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'twenty-plus-devices', enabled: true, priority: 110,
        conditions: { minReceiverTarget: 21 },
        recommendation: {
          title: 'AirCast expandable setup',
          subtitle: 'Professional transmitter with custom receiver and headphone quantities',
          reasonBullets: ['Built around a professional venue transmitter', 'Receiver and headphone packs can scale beyond 20 listeners', 'Final pack quantity should be confirmed with a solution advisor'],
          groups: {
            transmitter: [{ productId: 'aircast', quantity: 1, reason: 'Provides the main Auracast broadcast.' }],
            receivers: [
              { productId: 'auraclip_10rx', quantity: 'receiverPacks10', reason: 'Provides venue receivers in groups of 10.' },
              { productId: 'wired_headphones_10', quantity: 'receiverPacks10', reason: 'Pairs a venue headphone with each AuraClip receiver.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'two-hundred-one-to-five-hundred-seats', enabled: true, priority: 105,
        conditions: { minVenueCapacity: 201, maxVenueCapacity: 500 },
        recommendation: {
          title: 'AuraPlex X20 Pro setup',
          subtitle: 'Long-range core system with 20 included listening devices',
          reasonBullets: ['Mapped to a 201–500 seat venue', 'Includes a managed mix of 20 listening devices and charging', 'Published line-of-sight range is up to 500 ft, subject to walls and interference'],
          groups: {
            transmitter: [{ productId: 'auraplex_x20', quantity: 1, reason: 'Combines the professional transmitter and a 20-device listener pool.' }],
            receivers: [{ productId: 'wired_headphones_10', quantity: 1, reason: 'Provides listening headphones for the 10 included AuraClip receivers.' }],
            accessories: []
          }
        }
      },
      {
        id: 'eleven-to-twenty-devices', enabled: true, priority: 100,
        conditions: { minReceiverTarget: 11, maxReceiverTarget: 20 },
        recommendation: {
          title: 'AuraPlex X20 Pro setup',
          subtitle: 'Core transmitter system with 20 included listening devices',
          reasonBullets: ['Sized for a venue-provided listening pool up to 20', 'Includes several listening styles plus charging', 'Compatible Auracast hearing aids can also receive the broadcast directly'],
          groups: {
            transmitter: [{ productId: 'auraplex_x20', quantity: 1, reason: 'Combines the transmitter and a 20-device listener pool.' }],
            receivers: [{ productId: 'wired_headphones_10', quantity: 1, reason: 'Provides listening headphones for the 10 included AuraClip receivers.' }],
            accessories: []
          }
        }
      },
      {
        id: 'fifty-one-to-two-hundred-seats', enabled: true, priority: 95,
        conditions: { minVenueCapacity: 51, maxVenueCapacity: 200 },
        recommendation: {
          title: 'AuraPlex MX setup',
          subtitle: 'Core transmitter system with 10 venue receivers',
          reasonBullets: ['Mapped to a 51–200 seat venue', 'Includes 10 venue receivers and a charging dock', 'Published line-of-sight range is up to 328 ft, subject to walls and interference'],
          groups: {
            transmitter: [{ productId: 'auraplex_mx', quantity: 1, reason: 'Combines the transmitter, 10 AuraClip receivers and charging.' }],
            receivers: [{ productId: 'wired_headphones_10', quantity: 1, reason: 'Pairs a venue headphone with each included AuraClip receiver.' }],
            accessories: []
          }
        }
      },
      {
        id: 'four-to-ten-devices', enabled: true, priority: 90,
        conditions: { minReceiverTarget: 4, maxReceiverTarget: 10 },
        recommendation: {
          title: 'AuraPlex MX setup',
          subtitle: 'Core transmitter system with 10 venue receivers',
          reasonBullets: ['Provides up to 10 venue receivers', 'Includes a charging dock for the receiver pool', 'Compatible Auracast hearing aids can also receive the broadcast directly'],
          groups: {
            transmitter: [{ productId: 'auraplex_mx', quantity: 1, reason: 'Combines the transmitter, 10 AuraClip receivers and charging.' }],
            receivers: [{ productId: 'wired_headphones_10', quantity: 1, reason: 'Pairs a venue headphone with each included AuraClip receiver.' }],
            accessories: []
          }
        }
      },
      {
        id: 'fallback', enabled: true, priority: 1,
        conditions: {},
        recommendation: {
          title: 'AuraPlex M3 starter setup',
          subtitle: 'Compact transmitter system with three venue receivers',
          reasonBullets: ['A compact starting point for a small venue or listening pool', 'Includes three AuraClip receivers', 'Published line-of-sight range is up to 328 ft, subject to walls and interference'],
          groups: {
            transmitter: [{ productId: 'auraplex_m3', quantity: 1, reason: 'Combines the transmitter and three AuraClip receivers.' }],
            receivers: [{ productId: 'wired_headphones_3', quantity: 1, reason: 'Pairs a venue headphone with each included AuraClip receiver.' }],
            accessories: []
          }
        }
      }
    ]
  };
})();
